import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { toggleBlockUI } from 'store/blockUI'
import { rootPath } from 'lib/Utils'

class NewsItem extends Component {
  componentDidMount () {
    // this.props.updateContent({ type: 'singlePost', 'title': 'News' })
    this.doAjaxCall()
  }

  componentDidUpdate () {
    // this.props.updateContent({ type: 'singlePost', 'title': 'News' })
    this.doAjaxCall()
  }

  doAjaxCall () {
    this.props.toggleBlockUI(true)
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })

    let contentObject = { type: 'singlePost', 'title': 'News' }

    // Do an ajax requesto to WP API in order to get
    // the posts and the categories
    wp.posts().slug(this.props.params.slug).embed().get()
    .then((data) => {
      this.props.toggleBlockUI(false)
      contentObject.item = data[0]
      if (data[0].acf.side_image) {
        contentObject.poster = data[0].acf.side_image.sizes.large
      } else if (data[0]._embedded['wp:featuredmedia'] && data[0]._embedded['wp:featuredmedia'].length > 0) {
        const featuredImage = data[0]._embedded['wp:featuredmedia'][0]
        if (featuredImage.hasOwnProperty('code') && featuredImage.code === 'rest_forbidden') {
          contentObject.poster = null
        } else {
          contentObject.poster = featuredImage.media_details.sizes.large.source_url
        }
      }
      this.props.updateContent(contentObject)
    })
    .catch((error) => {
      console.warn(error)
      this.props.toggleBlockUI(false)
    })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

NewsItem.propTypes = {
  updateContent: PropTypes.func,
  toggleBlockUI: PropTypes.func,
  params: PropTypes.object
}

export default connect(null, mapDispatchToProps)(NewsItem)



// WEBPACK FOOTER //
// ./src/routes/NewsItem/index.js